var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessIco4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131.345,
    height: 131.345,
    viewBox: "0 0 131.345 131.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1345.764 -2824.348)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46.437,
    cy: 46.437,
    r: 46.437,
    transform: "translate(1345.764 2890.02) rotate(-45)",
    fill: "#15de9b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1384.324 2862.909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3,28.053V.9a.9.9,0,0,0-.9-.9H11.764a.9.9,0,0,0-.9.9v9.954H.9a.9.9,0,0,0-.9.9V38.912a.9.9,0,0,0,.9.9H8.144a.955.955,0,0,0,.2-.04l5.285,13.936a.909.909,0,0,0,1.169.525h0L53.713,38.854a.9.9,0,0,0,.51-1.173h0l-3.417-8.724h2.584A.9.9,0,0,0,54.3,28.053ZM1.81,38.007V12.669H40.841l-4.865,1.81H4.525a.9.9,0,0,0-.9.9V35.292a.9.9,0,0,0,.9.9H6.99l.684,1.81ZM42.532,10.859H16.289V5.43H48.866v18.1h-.192L44.28,12.336a.9.9,0,0,0-.843-.565h0a.9.9,0,0,0-.9-.912ZM11.7,18.193a3.464,3.464,0,0,0-.843-.094A3.62,3.62,0,0,0,8.72,24.614L5.43,25.845V16.289h25.7L14.388,22.515A3.594,3.594,0,0,0,11.7,18.193Zm.966,3.526a1.81,1.81,0,1,1-1.81-1.81A1.81,1.81,0,0,1,12.669,21.718ZM6.3,34.387H5.43v-2.3ZM52.218,37.5,15,52.214,5.694,27.676,42.919,13.827Zm.268-10.349H50.1l-.724-1.81h.384a.9.9,0,0,0,.9-.9V4.525a.9.9,0,0,0-.9-.9H15.369a.9.9,0,0,0-.89.9v6.334h-1.81V1.81H52.486Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.111,64.617l-.847-2.262a.876.876,0,0,0-.3-.8l-6.07-15.927a.909.909,0,0,0-1.169-.525h0L23.143,57.775a.9.9,0,0,0-.518,1.166l7.239,19a.9.9,0,0,0,.822.568.934.934,0,0,0,.329-.062L63.593,65.782a.9.9,0,0,0,.518-1.166ZM32.684,61.681a.909.909,0,0,0-.188.485l-.88,14.117-.409.159-6.6-17.32L55.5,47.112l4.984,13.074-9.466-5.093a.9.9,0,0,0-1.223.362.883.883,0,0,0-.109.434v1.929l-6.736-4.492a.9.9,0,0,0-1.256.25.92.92,0,0,0-.145.384L39.935,66.108l-5.991-4.6a.9.9,0,0,0-1.26.174Zm.789,13.878L34.2,63.976l9.752,7.5ZM45.889,70.73a.873.873,0,0,0-.152-.174l-4.13-3.174,1.549-11.746,6.935,4.626a.9.9,0,0,0,1.256-.25.923.923,0,0,0,.152-.5V57.4l9.972,5.364.626,1.647Z",
    transform: "translate(-14.397 -28.742)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessIco4);
export default __webpack_public_path__ + "static/media/process_ico_4.e8b1e841abf2e4efe4cb5e0233ef36df.svg";
export { ForwardRef as ReactComponent };